import { useMyJobDescription } from '@/hooks/queries/useMyJobDescription'
import { useAuth } from '@/hooks/useAuth'
import { JDDetailView } from '@/components/JDDetailView'

const MyJDPage = () => {
  const { data: jobDescription, isLoading, error } = useMyJobDescription()
  const { user } = useAuth()

  return (
    <JDDetailView
      jobDescription={jobDescription}
      isLoading={isLoading}
      error={error}
      isMyJD={true}
      queryKey={['myJobDescription']}
      userName={user?.name}
    />
  )
}

export default MyJDPage
